import React from 'react';
import { Box, Typography } from '@mui/material';
import tailfinLogo from '@/assets/img/tailfin-logo.png';

const PoweredByTailfin = ({ size = 'medium', sx = {}, ...props }) => {
  const getSizes = () => {
    switch (size) {
      case 'small':
        return {
          logoHeight: '30px',
          fontSize: '0.75rem',
          spacing: 1,
        };
      case 'large':
        return {
          logoHeight: '60px',
          fontSize: '.8rem',
          spacing: 0,
        };
      default:
        // medium
        return {
          logoHeight: '40px',
          fontSize: '0.775rem',
          spacing: 1,
        };
    }
  };

  const sizes = getSizes();

  return (
    <Box
      display='flex'
      flexDirection='row'
      alignItems='center'
      gap={sizes.spacing}
      sx={sx}
      {...props}>
      <Typography
        variant='body2'
        sx={{
          fontSize: sizes.fontSize,
          fontWeight: 500,
          color: 'text.secondary',
          textAlign: 'center',
          letterSpacing: '0.5px',
        }}>
        Powered By
      </Typography>
      <img
        src={tailfinLogo}
        alt='Tailfin Logo'
        style={{
          height: sizes.logoHeight,
          width: 'auto',
          objectFit: 'contain',
        }}
      />
    </Box>
  );
};

export default PoweredByTailfin;
